export const DIGITAL_WALLET_BALANCE_WARNING_RATE = 30;
